<!-- 微信二维码 -->
<template>
    <div class="year">
        <!-- <van-field center v-model="queryParams.taskYear" is-link readonly arrow-direction="down" @click="dateSelect" /> -->
        <div class="text" @click="dateSelect">{{
            queryParams.taskYear
        }}
            <van-icon class="arrow" name="arrow-down" />
        </div>
        <van-popup round position="bottom" v-model="yearShow">
            <van-picker title="请选择年份" v-model="queryParams.taskYear" show-toolbar :columns="yearColumns"
                :default-index="yearSelect" @confirm="yearConfirm" @cancel="cancel" />
        </van-popup>

    </div>
</template>
<script>

export default {
    props: {
        year: String
    },
    data() {
        return {
            // 查询参数
            queryParams: {
                taskYear: '',
            },
            yearSelect: null,
            yearColumns: [],
            yearShow: false // 年份
        }
    },
    created() {
        this.queryParams.taskYear = String(new Date().getFullYear())
        this.yearData();
    },
    methods: {
        formatDates(date) {
            return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
        },
        // 监听年份打开
        dateSelect() {
            this.yearShow = true;
        },
        //年选择器
        yearConfirm(value, index) {
            // console.log('value', value)
            this.queryParams.taskYear = String(this.yearColumns[index])
            this.yearShow = false;
            this.$emit('confirm', value)
        },
        //年数据
        yearData() {
            // 获取默认显示的时间
            var nowTime = new Date(this.queryParams.taskYear);
            let year = nowTime.getFullYear();
            let month = nowTime.getMonth();
            let day = nowTime.getDate();
            // 循环数组 填写最小时间和最大时间范围 推进数组
            for (let i = 2000; i < 2099; i++) {
                this.yearColumns.push(i);
            }
            // 格式化时间并截取
            var years = this.formatDates(new Date(year, month, day));
            var Year = years.slice(0, 4);
            // 将截取的年份赋值给绑定值 用于点击弹出日期窗口后显示当前的时间
            this.yearSelect = this.yearColumns.indexOf(Number(Year));
        },
        // 点击取消按钮时触发的事件
        cancel() {
            this.yearShow = false;
        },
    }


}

</script>
<style lang="less" scoped>
.year {
    width: 100%;
    height: 100%;
}

.van-cell {
    border: 1px solid #E9E9E9;
    border-radius: 18px 18px 18px 18px;
    text-align: center !important;

}

.text {
    position: relative;
    text-align: left;
    height: 36px;
    line-height: 36px;
    padding-left: 20px;

    .arrow {
        position: absolute;
        right: 10px;
        top: 10px;
    }
}
</style>